// ─── Cuotas en llano ─────────────────────────────────────────────────────────
// Las comparten la Mesa de cruces (reglas, cobros) y el modal de autorización
// (las reglas de la base). Funciones puras.

/** Cuotas sin repetidas y de menor a mayor, como las deja la API. */
export const normalizeInstallments = (list: readonly number[]): number[] =>
	Array.from(new Set(list)).sort((a, b) => a - b);

/** [1, 2, 3, 4, 5, 6, 10] → "1 a 6, 10". Ordena y saca repetidas antes. */
export function formatInstallments(list: readonly number[]): string {
	const installments = normalizeInstallments(list);
	const runs: string[] = [];
	let start = 0;
	for (let i = 1; i <= installments.length; i += 1) {
		if (i === installments.length || installments[i] !== installments[i - 1] + 1) {
			const [from, to] = [installments[start], installments[i - 1]];
			runs.push(from === to ? String(from) : `${from} a ${to}`);
			start = i;
		}
	}
	return runs.join(', ');
}

/**
 * Las cuotas de una regla, armadas siempre de la lista y nunca de `installmentsLabel`
 * (la semilla dice "Hasta 6" o "1 a 6" para lo mismo): "1 a 6", "10", "1, 3, 6" o "—".
 */
export const describeInstallments = (installments: readonly number[]): string =>
	formatInstallments(installments) || '—';
